<template>
    <div class="login-fade">
        <div class="login">
            <button @click="loginCloseClick" class="login-close">
                <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.00342 2L20.6685 20.6651"
                        stroke="black"
                        stroke-width="3"
                        stroke-linecap="round"
                    />
                    <path
                        d="M20.665 2L1.99993 20.6651"
                        stroke="black"
                        stroke-width="3"
                        stroke-linecap="round"
                    />
                </svg>
            </button>
            <div class="login-form">
                <p class="login-title">{{ modalTitle }}</p>
                <form id="login" @submit="submitForm($event)">
                    <div class="input-wrapper">
                        <svg
                            class="input-icon"
                            width="15"
                            height="18"
                            viewBox="0 0 15 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.49981 9.61661C9.55178 9.61661 11.2211 7.57516 11.2211 5.06578C11.2211 2.67411 9.69072 1.00391 7.49981 1.00391C5.3087 1.00391 3.77836 2.67411 3.77836 5.06578C3.77836 7.57516 5.44764 9.61661 7.49981 9.61661ZM7.49981 2.27495C8.98466 2.27495 9.982 3.39661 9.982 5.06557C9.982 6.87391 8.86847 8.34536 7.49981 8.34536C6.13116 8.34536 5.01763 6.87391 5.01763 5.06557C5.01763 3.39661 6.01517 2.27495 7.49981 2.27495ZM7.11895 11.0402H7.88047C11.4896 11.0402 13.9139 13.1785 13.9137 16.361C13.9137 16.7118 13.6364 16.9962 13.2944 16.9962C12.9519 16.9962 12.6746 16.7118 12.6746 16.361C12.6746 13.3718 10.0919 12.3114 7.88047 12.3114H7.11875C4.90733 12.3114 2.3252 13.3716 2.3252 16.361C2.3252 16.7118 2.04773 16.9962 1.70547 16.9962C1.36341 16.9962 1.08594 16.7118 1.08594 16.361C1.08594 13.1787 3.51044 11.0402 7.11895 11.0402Z"
                                fill="#6F96D7"
                            />
                            <path
                                d="M13.9137 16.361L13.7137 16.361V16.361H13.9137ZM11.0211 5.06578C11.0211 7.50421 9.40557 9.41661 7.49981 9.41661V9.81661C9.69799 9.81661 11.4211 7.6461 11.4211 5.06578H11.0211ZM7.49981 1.20391C8.5418 1.20391 9.41772 1.5998 10.0346 2.27307C10.6526 2.94763 11.0211 3.91264 11.0211 5.06578H11.4211C11.4211 3.82726 11.0244 2.76132 10.3295 2.00286C9.63343 1.24312 8.64873 0.803906 7.49981 0.803906V1.20391ZM3.97836 5.06578C3.97836 3.91264 4.34685 2.94764 4.96488 2.27308C5.58174 1.5998 6.45772 1.20391 7.49981 1.20391V0.803906C6.35079 0.803906 5.36605 1.24311 4.66996 2.00286C3.97504 2.76132 3.57836 3.82726 3.57836 5.06578H3.97836ZM7.49981 9.41661C5.59384 9.41661 3.97836 7.50421 3.97836 5.06578H3.57836C3.57836 7.64611 5.30144 9.81661 7.49981 9.81661V9.41661ZM10.182 5.06557C10.182 4.19182 9.9206 3.44381 9.44717 2.91149C8.9719 2.37711 8.29567 2.07495 7.49981 2.07495V2.47495C8.18879 2.47495 8.75366 2.73362 9.14828 3.17732C9.54472 3.62307 9.782 4.27037 9.782 5.06557H10.182ZM7.49981 8.54536C8.26063 8.54536 8.93558 8.13596 9.41363 7.50429C9.89165 6.87265 10.182 6.0094 10.182 5.06557H9.782C9.782 5.93008 9.51558 6.70673 9.09467 7.2629C8.67379 7.81904 8.10765 8.14536 7.49981 8.14536V8.54536ZM4.81763 5.06557C4.81763 6.0094 5.10797 6.87265 5.58599 7.50429C6.06404 8.13596 6.73899 8.54536 7.49981 8.54536V8.14536C6.89198 8.14536 6.32583 7.81904 5.90495 7.2629C5.48404 6.70673 5.21763 5.93008 5.21763 5.06557H4.81763ZM7.49981 2.07495C6.70405 2.07495 6.02782 2.37712 5.55254 2.91148C5.07908 3.4438 4.81763 4.19181 4.81763 5.06557H5.21763C5.21763 4.27038 5.45495 3.62308 5.85142 3.17732C6.24607 2.73361 6.81094 2.47495 7.49981 2.47495V2.07495ZM7.88047 10.8402H7.11895V11.2402H7.88047V10.8402ZM14.1137 16.361C14.1138 14.7157 13.4856 13.3297 12.3829 12.3571C11.2824 11.3865 9.72387 10.8402 7.88047 10.8402V11.2402C9.64619 11.2402 11.1044 11.7629 12.1183 12.6571C13.13 13.5494 13.7138 14.8238 13.7137 16.361L14.1137 16.361ZM13.2944 17.1962C13.7516 17.1962 14.1137 16.8175 14.1137 16.361H13.7137C13.7137 16.6062 13.5212 16.7962 13.2944 16.7962V17.1962ZM12.4746 16.361C12.4746 16.8176 12.8368 17.1962 13.2944 17.1962V16.7962C13.067 16.7962 12.8746 16.6061 12.8746 16.361H12.4746ZM7.88047 12.5114C8.95884 12.5114 10.1138 12.7707 10.9929 13.3797C11.8628 13.9822 12.4746 14.934 12.4746 16.361H12.8746C12.8746 14.7988 12.1951 13.7258 11.2207 13.0509C10.2556 12.3823 9.01352 12.1114 7.88047 12.1114V12.5114ZM7.11875 12.5114H7.88047V12.1114H7.11875V12.5114ZM2.5252 16.361C2.5252 14.9339 3.13691 13.9821 4.00659 13.3796C4.88557 12.7706 6.04038 12.5114 7.11875 12.5114V12.1114C5.9857 12.1114 4.74374 12.3823 3.7788 13.0508C2.80456 13.7257 2.1252 14.7987 2.1252 16.361H2.5252ZM1.70547 17.1962C2.16281 17.1962 2.5252 16.8176 2.5252 16.361H2.1252C2.1252 16.606 1.93266 16.7962 1.70547 16.7962V17.1962ZM0.885937 16.361C0.885937 16.8176 1.24829 17.1962 1.70547 17.1962V16.7962C1.47852 16.7962 1.28594 16.6061 1.28594 16.361H0.885937ZM7.11895 10.8402C5.27585 10.8402 3.71746 11.3866 2.61696 12.3572C1.51426 13.3298 0.885937 14.7158 0.885937 16.361H1.28594C1.28594 14.8239 1.86987 13.5495 2.88154 12.6572C3.89542 11.763 5.35355 11.2402 7.11895 11.2402V10.8402Z"
                                fill="#6F96D7"
                            />
                        </svg>
                        <input
                            class="input"
                            type="text"
                            placeholder="Email"
                            v-model="email"
                            @animationstart="checkAnimation"
                            @input="changeEmail"
                        />
                    </div>
                    <p v-if="invalidEmailOrUsername" class="error-message">
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.00146 2L9.99992 9.99845"
                                stroke="#CE0000"
                                stroke-width="3"
                                stroke-linecap="round"
                            />
                            <path
                                d="M9.99854 2L2.00008 9.99845"
                                stroke="#CE0000"
                                stroke-width="3"
                                stroke-linecap="round"
                            />
                        </svg>
                        {{ invalidEmailOrUsername }}
                    </p>
                    <PasswordElemComponent
                        @change="changePassword($event)"
                        v-model="password"
                        :input="validateForm()"
                    />
                    <p v-if="invalidPassword" class="error-message">
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.00146 2L9.99992 9.99845"
                                stroke="#CE0000"
                                stroke-width="3"
                                stroke-linecap="round"
                            />
                            <path
                                d="M9.99854 2L2.00008 9.99845"
                                stroke="#CE0000"
                                stroke-width="3"
                                stroke-linecap="round"
                            />
                        </svg>
                        {{ invalidPassword }}
                    </p>

                    <button class="login-submit" type="submit" @click="submitForm($event)">Login</button>
                    <span @click="toForgotPassword" class="link-forgot"> Forgot password? </span>

                    <!-- <div class="divider"><span class="divider-text">OR</span></div>

                    <button class="btn-facebook" @click="fbLogin($event)">Sign In with Facebook</button> -->

                    <p class="sign-up">
                        Don't have an account?
                        <span @click="toSignUp" class="sign-up-link">Sign Up</span>
                    </p>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PasswordElemComponent from './elems/form-password';
import appIds from '../../../config/apps';
import * as Facebook from '../../components/fbSdkWrapper';

import { safariDetect } from '../../functions/mobileDetect';

const apiUrl = process.env.BASE_URL;
const appId = appIds[process.env.NODE_ENV];

export default {
    components: {
        PasswordElemComponent,
    },
    data() {
        return {
            appId: appId,
            email: '',
            password: '',
            isValid: false,
            invalidEmailOrUsername: '',
            invalidPassword: '',
            serverError: '',
            autofilled: false,
        };
    },

    computed: {
        ...mapGetters(['searchedUsers']),
        ...mapGetters('auth', ['getLoginStay']),

        modalTitle() {
            return this.searchedUsers.access ? 'Login' : 'Login to Connect';
        },
    },

    created() {
        Facebook.load().then(() => {
            Facebook.init({
                appId,
            });
        });
    },
    methods: {
        loginCloseClick() {
            sessionStorage.removeItem('uploadModal');

            this.$store.dispatch('auth/setLoginStay', false);
            this.loginClose();
        },
        loginClose() {
            this.$emit('loginClose');
        },
        toSignUp() {
            // if (localStorage.getItem('token')) {
            //     const payload = {
            //         active: true,
            //         type: 'error',
            //         text: 'It looks like you are already logged in on another tab. Please logout to sign up as new user.',
            //     };

            //     this.$store.dispatch('setToast', payload);
            //     return;
            // }

            this.$emit('goToSignUp');
        },
        toForgotPassword() {
            this.$emit('goToForgotPassword');
        },
        saveUserData(data) {
            this.$store.dispatch('auth/setUserData', data);
        },

        fbLogin(e) {
            e.preventDefault();

            // if (localStorage.getItem('token')) {
            //     const payload = {
            //         active: true,
            //         type: 'error',
            //         text: 'It looks like you are already logged in on another tab. Please logout to login as another user.',
            //     };

            //     this.$store.dispatch('setToast', payload);
            //     return;
            // }

            const token = '';
            Facebook.login().then((response) => {
                if (response.status === 'connected') {
                    // logged in
                    const fd = new FormData();
                    fd.append('access_token', response.authResponse.accessToken);
                    fetch(`${apiUrl}/api/auth/facebook/session`, {
                        method: 'POST',
                        body: fd,
                    })
                        .then((resp) => {
                            if (resp.status !== 422) {
                                return resp.json();
                            } else {
                                const toastText =
                                    'You have never been registered! Please register first and try again.';
                                this.$emit('showNotification', toastText);
                                return resp.json();
                            }
                        })
                        .then((data) => {
                            // if (localStorage.getItem('token')) {
                            //     const payload = {
                            //         active: true,
                            //         type: 'error',
                            //         text: 'It looks like you are already logged in on another tab. Please logout to login as another user.',
                            //     };

                            //     this.$store.dispatch('setToast', payload);
                            //     return;
                            // }
                            this.saveUserData(data);
                            this.loginClose();
                            if (safariDetect() || this.isSafari()) sessionStorage.setItem('refresh', true);
                            this.$router.push({ name: 'Profile' });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } else {
                    console.log(err);
                }
            });
        },
        validateForm() {
            if (
                !this.email ||
                !this.password ||
                this.serverError ||
                this.invalidEmailOrUsername ||
                this.invalidPassword
            ) {
                this.isValid = false;
            } else if (this.autofilled) {
                this.isValid = true;
            } else {
                this.isValid = true;
            }
        },
        changeEmail() {
            this.serverError = '';
            this.invalidEmailOrUsername = '';
        },
        changePassword(e) {
            this.password = e;
            this.serverError = '';
            this.invalidPassword = '';
        },
        isSafari() {
            if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                return true;
            }

            return false;
        },
        checkAnimation(e) {
            if (e.animationName == 'onAutoFillStart') {
                this.autofilled = true;
                this.validateForm();
            } else if (e.animationName == 'onAutoFillCancel') {
                this.autofilled = false;
            }
        },
        submitForm(e) {
            e.preventDefault();
            this.validateForm();

            const form = document.getElementById('login');
            const fd = new FormData(form);

            fd.append('session[email]', this.email);
            fd.append('session[password]', this.password);
            fetch(`${apiUrl}/api/auth/session`, {
                method: 'POST',
                body: fd,
            })
                .then((resp) => {
                    return resp.json();
                })
                .then(async (data) => {
                    const { errors } = await data;

                    if (errors) {
                        const emailError = errors.find((item) => item.attribute === 'email');
                        const passwordError = errors.find(
                            (item) => item.attribute === 'password' || item.attribute === 'base'
                        );

                        this.invalidEmailOrUsername = emailError ? emailError.title : '';
                        this.invalidPassword = passwordError ? passwordError.title : '';

                        this.autofilled = false;
                    } else {
                        // if (localStorage.getItem('token')) {
                        //     const payload = {
                        //         active: true,
                        //         type: 'error',
                        //         text: 'It looks like you are already logged in on another tab. Please logout to login as another user.',
                        //     };

                        //     this.$store.dispatch('setToast', payload);
                        //     return;
                        // }
                        this.saveUserData(data);
                        this.loginClose();

                        if (this.searchedUsers.access) {
                            if (safariDetect() || this.isSafari()) {
                                sessionStorage.setItem('refresh', true);
                            }

                            if (!this.getLoginStay) {
                                this.$router.push('/profile');
                            }
                        }
                    }
                    this.$store.dispatch('auth/setLoginStay', false);
                    this.$store.dispatch('getCurrency');
                    this.$store.dispatch('getPaymentData');
                    this.$emit('checkReward');
                })
                .catch((err) => {
                    this.serverError = err;
                });
        },
    },
};
</script>

<style scoped>
.login-title {
    margin-bottom: 41px;
    font-family: 'Montserrat Bold';
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    line-height: 37px;
    color: #1e2541;
    text-align: center;
}

@media (max-width: 767px) {
    .login-title {
        font-size: 24px;
        line-height: 1;
    }
}

.login-fade {
    padding: 50px 20px;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(242, 242, 242, 0.85);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    z-index: 999;
    overflow-x: hidden;
    overflow-y: auto;
}

@media (max-width: 991px) {
    .login-fade {
        padding-top: 100px;
    }
}

.login {
    position: relative;
    display: flex;
    justify-content: center;
    align-self: center;
    margin: 0 20px;
    padding: 58px 70px 52px;
    max-width: 456px;
    height: fit-content;
    width: 100%;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0px 4px 10px rgba(44, 145, 179, 0.3);
}

@media (max-width: 991px) {
    .login {
        padding: 58px 20px 52px;
    }
}

.login-form {
    width: 100%;
}

.login-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 19px;
    height: 19px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
}

.input-wrapper {
    margin-bottom: 15px;
    position: relative;
    height: 50px;
    display: flex;
    align-items: center;
    border: 1px solid #d1d8dd;
    border-radius: 35px;
    overflow: hidden;
    z-index: 1;
}

.input-icon {
    margin-left: 31px;
    position: relative;
    z-index: 1;
    pointer-events: none;
}

.input {
    padding: 17px 31px 17px 54px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    border: none;
    outline: none;
    color: #3a4146;
}

.input::placeholder {
    color: #3a4146;
}

.login-submit {
    display: block;
    margin: 36px auto 0;
    width: 100%;
    height: 50px;
    color: #fff;
    background: linear-gradient(315deg, #1f32c7 0%, #3cd1f3 100%);
    border-radius: 23px;
    border: none;
    font-family: SF Pro Display;
    font-style: normal;
    font-size: 16px;
    cursor: pointer;
}

.divider {
    margin: 0 auto 40px;
    max-width: 200px;
    position: relative;
    display: flex;
    justify-content: center;
}

.divider:after {
    content: '';
    width: 100%;
    height: 1px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: #6f96d7;
}

.divider-text {
    width: 40px;
    display: flex;
    justify-content: center;
    font-family: 'SF Pro Display';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #2969d6;
    background: #fff;
    position: relative;
    z-index: 1;
}

.sign-up {
    font-family: 'SF Pro Display';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #757575;
    text-align: center;
}

.sign-up-link {
    color: #2969d6;
    cursor: pointer;
}
</style>
